import { useEffect, useState } from "react";
import {
  useStripe,
} from "@stripe/react-stripe-js";
import {  toast } from "react-toastify";
import axios from "axios";

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";

function PaymentExistingSuccess() {
    // alert("herer")
  const [message, setMessage] = useState(null);
  const stripe = useStripe();

  const handleSuccess = async (paymentId) => {
    await axios.post(API + 'accounting/paymentretrieve/', { paymentId: paymentId },
      {
        headers: authHeader()
      }).then((response) => {
        if (response.data.success === 1) {
          const body = {
            amount: response.data.response.amount,
            inoviceid: response.data.response.metadata.inoviceid,
            customer_id:response.data.response.metadata.customer_id ,
            applied_amount:0
          }
          axios.post(API + "accounting/paymentreceiptapply/", {
            
            amount: (response.data.response.amount)/100,
            invoiceid: response.data.response.metadata.inoviceid,
            customer_id:response.data.response.metadata.customer_id ,
            applied_amount:0,
            receipt_refrence:paymentId
          },{headers: authHeader(),}).then((response)=>{
            if (response.data.success) {
              toast.success(`${response.data.response}`, {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
            else{
              toast.error(`${response.data.error}`, {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });

            }
          })
        }
      })
  }

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }


    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      const paymentId = paymentIntent.id
      handleSuccess(paymentId)
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Please log a support ticket or send email to support@athenafintech.com.");
          break;
      }
    })
  }, [stripe]);
  return (
    <>
      <div className="container-fluid pt-8">
        <div className="cardsucess bodysucess justify-content-center">
          <div className="divsucess" style={{ height: '100px', width: '100px' }}>
            <i className="checkmark isucess" style={{ lineHeight: '100px', fontSize: '50px', marginLeft: '-7px' }}>✓</i>
          </div>

          <h1 className="hsucess">Your payment success!</h1>
          <p className="psucess">Thank you for your payment. Your transaction has been processed successfully.
            </p><br />
        </div>
      </div>
    </>
  );
}

export default PaymentExistingSuccess;